import { Components, Theme } from '@mui/material';

export const tabsStyles: Components<Theme>['MuiTabs'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '& .MuiTab-root': {
        padding: '12px',
        textTransform: 'none',
        color: theme.palette.customGrey.dark,
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: 600,
        '&.Mui-selected': {
          backgroundColor: theme.palette.customGrey.light,
          color: theme.palette.customGrey.dark
        }
      }
    })
  }
};
